import { CONTACT } from '@/statics/constants';
import Link from 'next/link';

export const policyItems = [
  {
    key: '1',
    label: 'Điều 1. Quy định chung',
    children: (
      <>
        <div>
          <label>1.1</label>
          <p>
            Chính sách bảo vệ dữ liệu cá nhân là một phần không thể tách rời của
            các hợp đồng/thỏa thuận giữa Khách hàng và Vietstats, điều khoản sử
            dụng, quy định, thông báo khác thông qua các kênh thông tin mà
            Vietstats cho là phù hợp trong từng thời kỳ.
          </p>
        </div>
        <div>
          <label>1.2</label>
          <p>
            Vietstats cam kết luôn tôn trọng, luôn nỗ lực và sử dụng các biện
            pháp phù hợp để bảo vệ dữ liệu cá nhân của khách hàng theo quy định
            của pháp luật Việt Nam.
          </p>
        </div>
        <div>
          <label>1.3</label>
          <p>
            Tùy vào vai trò của Vietstats trong từng tình huống, gồm (a) Bên
            kiểm soát dữ liệu cá nhân, (b) Bên Xử lý dữ liệu cá nhân, (c) Bên
            kiểm soát và xử lý dữ liệu, hoặc (d) Bên thứ ba theo quy định của
            pháp luật, Vietstats thực hiện các quyền hạn và nghĩa vụ theo quy
            định của pháp luật Việt Nam.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '2',
    label: 'Điều 2. Giải thích từ ngữ',
    children: (
      <>
        <div>
          <label>2.1</label>
          <p>
            <span>Khách hàng</span> là cá nhân/tổ chức sử dụng hoặc truy cập
            Website, tiếp cận, tìm hiểu, đăng ký, thanh toán, sử dụng hoặc có
            liên quan đến các sản phẩm, dịch vụ của Vietstats.
          </p>
        </div>
        <div>
          <label>2.2</label>
          <p>
            <span>Vietstats</span> là Công ty TNHH Tư vấn chiến lược chính sách
            và phân tích dữ liệu kinh tế Vietstats.
          </p>
        </div>
        <div>
          <label>2.3</label>
          <p>
            <span>Website</span> là trang thông tin điện tử Vietstats.vn
          </p>
        </div>
        <div>
          <label>2.4</label>
          <p>
            <span>Sản phẩm, dịch vụ của Vietstats</span> là tất cả sản phẩm,
            dịch vụ do Vietstats cung cấp tại từng thời điểm, bao gồm nhưng
            không giới hạn sản phẩm, dịch vụ trên Website.
          </p>
        </div>
        <div>
          <label>2.5</label>
          <p>
            <span>Dữ liệu cá nhân</span> là thông tin dưới dạng ký hiệu, chữ
            viết, chữ số, hình ảnh, âm thanh hoặc dạng tương tự trên môi trường
            điện tử gắn liền với một con người cụ thể hoặc giúp xác định một con
            người cụ thể. Dữ liệu cá nhân bao gồm dữ liệu cá nhân cơ bản và dữ
            liệu cá nhân nhạy cảm theo quy định của Nghị định số 13/2023/NĐ-CP
            ngày 17/04/2023.
          </p>
        </div>
        <div>
          <label>2.6</label>
          <p>
            <span>Xử lý dữ liệu cá nhân</span> là một hoặc nhiều hoạt động tác
            động tới dữ liệu cá nhân, như: thu thập, ghi, phân tích, xác nhận,
            lưu trữ, chỉnh sửa, công khai, kết hợp, truy cập, truy xuất, thu
            hồi, mã hóa, giải mã, sao chép, chia sẻ, truyền đưa, cung cấp,
            chuyển giao, xóa, hủy dữ liệu cá nhân hoặc các hành động khác có
            liên quan.
          </p>
        </div>
        <div>
          <label>2.7</label>
          <p>
            <span>Bảo vệ dữ liệu cá nhân</span> là hoạt động phòng ngừa, phát
            hiện, ngăn chặn, xử lý hành vi vi phạm liên quan đến dữ liệu cá nhân
            theo quy định của pháp luật.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '3',
    label: 'Điều 3. Loại dữ liệu cá nhân được sử dụng',
    children: (
      <>
        <div>
          <label>3.1</label>
          <p>
            Khách hàng đồng ý rằng Vietstats và/hoặc bên thứ ba hợp tác với
            Vietstats được xử lý tất cả dữ liệu cá nhân của Khách hàng và tất cả
            thông tin, tài liệu do Khách hàng cung cấp cho các mục đích phù hợp
            với quy định pháp luật, bao gồm nhưng không giới hạn dữ liệu các
            nhân cơ bản và dữ liệu cá nhân nhạy cảm.
          </p>
        </div>
        <div>
          <label>3.2</label>
          <p>
            Khi Khách hàng cung cấp Dữ liệu cá nhân của các cá nhân khác (ví dụ
            như thông tin liên hệ của cá nhân khác để mua sản phẩm/dịch vụ) cho
            Vietstats, Khách hàng hiểu rõ rằng mình đang đóng vai trò Bên Kiểm
            soát Dữ liệu cá nhân (là bên có quyền quyết định mục đích và phương
            tiện xử lý dữ liệu cá nhân) đối với việc cung cấp Dữ liệu cá nhân
            của các chủ thể này cho Vietstats, và Vietstats chỉ xử lý Dữ liệu cá
            nhân của các chủ thể này trên cơ sở thỏa thuận với Khách hàng cho
            các Mục đích xử lý tại Điều 4 của Chính sách Bảo mật này. Khách hàng
            có trách nhiệm đảm bảo rằng các cá nhân này đã được thông báo đầy đủ
            về các Mục đích xử lý có liên quan và việc xử lý Dữ liệu cá nhân
            theo quy định pháp luật và có được sự đồng ý của họ trước khi cung
            cấp thông tin đó cho Vietstats.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '4',
    label: 'Điều 4. Mục đích xử lý dữ liệu cá nhân',
    children: (
      <>
        <div>
          <p>
            Khách hàng đồng ý cho phép Vietstats xử lý dữ liệu cá nhân của Khách
            hàng và chia sẻ kết quả xử lý dữ liệu cho các mục đích sau:
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Xác định hoặc xác thực danh tính của Khách hàng nhằm xác minh tính
            chính xác, đầy đủ của các thông tin về Khách hàng giúp quản lý tài
            khoản trực tuyến mà Khách hàng có thể đã thiết lập với Vietstats.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Liên lạc với Khách hàng, bao gồm nhưng không giới hạn để xác nhận
            các giao dịch, gửi thông báo về các giao dịch và thực hiện, nhận các
            khoản thanh toán; trao đổi thông tin về quyền lợi, cập nhật các thay
            đổi đối với sản phẩm dịch vụ và tiện ích; thực hiện khảo sát; đề
            xuất, giới thiệu các chương trình khuyến mãi hay thông tin khác mà
            Vietstats cho rằng Khách hàng có thể quan tâm.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Nhằm mang đến trải nghiệm sản phẩm/dịch vụ tốt hơn cho Khách hàng
            khi sử dụng sản phẩm/dịch vụ của Vietstats, Vietstats sẽ thiết lập
            và sử dụng cookie để tìm hiểu thêm về cách Khách hàng tương tác
            Website.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Chăm sóc khách hàng, hỗ trợ khách hàng, cập nhật thông tin khách
            hàng khi mua, sử dụng sản phẩm/dịch vụ do Vietstats và/hoặc đối tác
            của Vietstats cung cấp. Điều tra, giải quyết thắc mắc, khiếu nại.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Cung cấp, đánh giá, phân tích chất lượng, nâng cấp, cải tiến sản
            phẩm dịch vụ của Vietstats; cá nhân hóa, nâng cao trải nghiệm của
            Khách hàng; quản lý và đánh giá các hoạt động kinh doanh hoặc thực
            hiện các hoạt động truyền thông tiếp thị; thực hiện nghiên cứu thị
            trường về nhân khẩu học, sở thích và quảng cáo hoặc mua hàng và các
            hành vi khác của Khách hàng.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Tổ chức, tham gia vào các cuộc thi, chương trình khuyến mại, khuyến
            mãi và hoặc/trao cho Khách hàng cơ hội tham gia vào các chương trình
            này.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Để đáp ứng, tuân thủ các chính sách nội bộ của Vietstats; ngăn chặn
            và phòng chống gian lận, đánh cắp danh tính và các hoạt động bất hợp
            pháp khác; các thủ tục, quy định, hướng dẫn, chỉ thị hoặc yêu cầu
            được ban hành bởi cơ quan nhà nước có thẩm quyền.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Để bảo vệ hoặc thực thi các quyền của Vietstats, bao gồm cả mục đích
            thu phí dịch vụ và/hoặc thu hồi bất kỳ khoản nợ nào theo thỏa thuận
            giữa Khách hàng và Vietstats.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Sản phẩm dịch vụ của Vietstats có thể đăng quảng cáo và quảng cáo có
            thể bao gồm các đường dẫn tới các website, ứng dụng khác.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Cho mục đích của các giao dịch chuyển nhượng, chuyển giao, mua bán
            sáp nhập tiềm năng, được đề xuất hoặc thực tế của Vietstats hoặc cho
            các mục đích liên quan đến việc tổ chức lại doanh nghiệp của
            Vietstats.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Các mục đích khác không được đề cập ở trên nhưng được quy định rõ
            trong sản phẩm, dịch vụ cụ thể do Vietstats cung cấp.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Phục vụ nhu cầu hoạt động kinh doanh của Vietstats và các mục đích
            khác do Vietstats quyết định phù hợp với quy định pháp luật.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Cho bất kỳ mục đích nào khác được yêu cầu hoặc cho phép bởi quy định
            pháp luật và/hoặc yêu cầu của cơ quan nhà nước có thẩm quyền, các
            tiêu chuẩn ngành có liên quan và các chính sách hiện hành khác của
            Vietstats.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '5',
    label: 'Điều 5. Mục đích xử lý dữ liệu cá nhân',
    children: (
      <>
        <div>
          <p>
            Khách hàng hiểu rõ và đồng ý rằng, Vietstats được xử lý dữ liệu cá
            nhân của Khách hàng bằng mọi cách thức phù hợp với Mục đích xử lý dữ
            liệu cá nhân và quy định pháp luật, bao gồm nhưng không giới hạn các
            cách thức sau:
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Thu thập dữ liệu cá nhân: Vietstats có thể thu thập trực tiếp hoặc
            gián tiếp dữ liệu cá nhân từ Khách hàng trong quá trình Vietstats
            cung cấp bất kỳ sản phẩm/dịch vụ nào cho Khách hàng và từ một hoặc
            một số nguồn được liệt kê sau đây, bao gồm nhưng không giới hạn:
            Thông qua quan hệ được thiết lập giữa Khách hàng và Vietstats; các
            nhà cung cấp, bên cung cấp dịch vụ, đối tác, liên kết và bên thứ ba
            có liên quan đến hoạt động kinh doanh của Vietstats; Các bên thứ ba
            có quan hệ Khách hàng và/hoặc Vietstats; Cơ quan chức năng có thẩm
            quyền; Hoạt động phân tích các hoạt động của Khách hàng trong quá
            trình sử dụng sản phẩm dịch vụ của Vietstats; Những nguồn của Bên
            thứ ba mà Khách hàng đồng ý việc chia sẻ hay cho phép xử lý dữ liệu
            cá nhân, hoặc những nguồn mà việc xử lý dữ liệu cá nhân được pháp
            luật cho phép.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Cung cấp, chuyển giao và tiết lộ dữ liệu cá nhân: Vietstats có thể
            tiết lộ dữ liệu cá nhân của Khách hàng hoặc dữ liệu cá nhân của Bên
            thứ ba có liên quan đến Khách hàng cho một hoặc các bên sau đây:
            Công ty mẹ, công ty con, công ty liên doanh liên kết, các tổ chức và
            cá nhân có liên quan đến hoạt động kinh doanh của Vietstats; Đối tác
            kinh doanh, nhà cung cấp sản phẩm dịch vụ, nhà quảng cáo; cơ quan
            nhà nước có thẩm quyền và/hoặc bất kỳ cá nhân, cơ quan có thẩm quyền
            hoặc cơ quan quản lý hoặc Bên thứ ba mà Vietstats được phép hoặc bắt
            buộc phải tiết lộ theo quy định pháp luật hoặc theo bất kỳ hợp đồng,
            thỏa thuận hoặc cam kết nào khác giữa Vietstats và Bên thứ ba; Bất
            kỳ cá nhân nào có liên quan đến việc thực thi hoặc duy trì bất kỳ
            quyền hoặc nghĩa vụ nào theo các thỏa thuận giữa Khách hàng và
            Vietstats; Bên thứ ba mà Khách hàng đồng ý hoặc Vietstats có cơ sở
            pháp lý để chia sẻ dữ liệu cá nhân của Khách hàng. Ngoài ra các đối
            tác của Vietstats có thể liên hệ với Khách hàng về sản phẩm dịch vụ
            và ưu đãi mà Vietstats tin rằng Khách hàng có thể quan tâm hoặc mang
            lại lợi ích cho Khách hàng.
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Chuyển giao dữ liệu cá nhân ra nước ngoài: Vietstats có thể cung
            cấp/chia sẻ dữ liệu cá nhân của Khách hàng đến các bên thứ ba liên
            quan của Vietstats và các bên thứ ba này có thể tại Việt Nam hoặc
            bất cứ địa điểm nào khác nằm ngoài lãnh thổ Việt Nam. Khi thực hiện
            việc cung cấp/chia sẻ dữ liệu cá nhân ra nước ngoài, Vietstats sẽ
            yêu cầu bên tiếp nhận đảm bảo rằng dữ liệu cá nhân của Khách hàng
            được chuyển giao cho họ sẽ bảo mật và an toàn. Vietstats đảm bảo
            tuân thủ các nghĩa vụ pháp lý và quy định liên quan đến việc chuyển
            giao dữ liệu cá nhân của Khách hàng.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '6',
    label:
      ' Điều 6. Tổ chức, cá nhân liên quan đến mục đích xử lý dữ liệu cá nhân',
    children: (
      <>
        <div>
          <p>
            Vietstats và các tổ chức, cá nhân khác hợp tác với Vietstats để thực
            hiện Mục đích xử lý dữ liệu cá nhân sẽ do Vietstats quyết định. Các
            tổ chức, cá nhân liên quan sẽ phải tuân thủ các yêu cầu về bảo vệ dữ
            liệu cá nhân của Khách hàng theo quy định của pháp luật.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '7',
    label: 'Điều 7. Quyền và nghĩa vụ của Khách hàng',
    children: (
      <>
        <div>
          <label>7.1</label>
          <p>
            Khách hàng có các quyền sau đây: Quyền được biết; Quyền đồng ý;
            Quyền truy cập; Quyền rút lại sự đồng ý: Quyền xóa dữ liệu: Quyền
            hạn chế xử lý dữ liệu: Quyền cung cấp dữ liệu: Quyền phải đối xử lý
            dữ liệu; Quyền khiếu nại, tố cáo, khởi kiện; Quyền yêu cầu bồi
            thường thiệt hại; Quyền tự bảo vệ và các quyền liên quan khác theo
            quy định pháp luật.
          </p>
        </div>
        <div>
          <label>7.2</label>
          <p>
            Khách hàng có nghĩa vụ tự bảo vệ dữ liệu cá nhân của mình, yêu cầu
            các tổ chức, cá nhân khác có liên quan bảo vệ dữ liệu cá nhân của
            mình; Tôn trọng, bảo vệ dữ liệu cá nhân của người khác; Cung cấp đầy
            đủ, chính xác dữ liệu cá nhân khi đăng ký và sử dụng dịch vụ và đồng
            ý cho phép xử lý dữ liệu cá nhân và khi có thay đổi về các thông tin
            này. Thực hiện quy định của pháp luật về bảo vệ dữ liệu cá nhân và
            tham gia phòng, chống các hành vi vi phạm quy định về bảo vệ dữ liệu
            cá nhân.
          </p>
        </div>
        <div>
          <label>7.3</label>
          <p>
            Vietstats khuyến nghị Khách hàng nên hạn chế truy cập tài khoản bằng
            đăng nhập tự động, chú ý chế độ sao lưu mật khẩu và đảm bảo đăng
            xuất khỏi tài khoản khi sử dụng các thiết bị chung. Vietstats sẽ
            không chịu trách nhiệm khi những thông tin cá nhân của Khách hàng bị
            rò rỉ vì bất kỳ lý do nào xuất phát từ Khách hàng.
          </p>
        </div>
        <div>
          <label>7.4</label>
          <p>
            Khách hàng có trách nhiệm thông báo kịp thời cho Vietstats ngay khi
            phát hiện thấy có sai sót, nhầm lẫn về dữ liệu cá nhân của mình hoặc
            nghi ngờ dữ liệu cá nhân của mình đang bị xâm phạm.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '8',
    label: 'Điều 8. Hậu quả, thiệt hại không mong muốn có thể xảy ra',
    children: (
      <>
        <div>
          <label>8.1</label>
          <p>
            Vietstats cam kết trong điều kiện phù hợp và khả năng cho phép nỗ
            lực đảm bảo tính bảo mật, an toàn, tuân thủ pháp luật để hạn chế các
            hậu quả, thiệt hại không mong muốn có khả năng xảy ra.
          </p>
        </div>
        <div>
          <label>8.2</label>
          <p>
            Vietstats thực hiện trách nhiệm bảo vệ dữ liệu cá nhân theo quy định
            pháp luật với các phương pháp bảo mật phù hợp và trong khả năng có
            thể, thường xuyên xem xét và cập nhật các biện pháp quản lý và kỹ
            thuật xử lý dữ liệu cá nhân của Khách hàng (nếu có).
          </p>
        </div>
        <div>
          <label>8.3</label>
          <p>
            Trong những trường hợp bất khả kháng theo quy định pháp luật và
            chính sách này, Khách hàng đồng ý với Vietstats rằng không có một hệ
            thống an ninh nào trên toàn thế giới có thể đảm bảo an toàn 100% và
            có thể có những nhân tố vượt ra ngoài tầm kiểm soát của Vietstats
            dẫn đến việc dữ liệu cá nhân của Khách hàng bị tiết lộ mà không phải
            do sự cố ý của Vietstats. Do vậy, Vietstats nỗ lực áp dụng các biện
            pháp phù hợp trong khả năng cho phép, nhưng không đảm bảo dữ liệu cá
            nhân của Khách hàng sẽ được bảo mật tuyệt đối khi xảy ra sự cố ngoài
            ý muốn của Vietstats.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '9',
    label: 'Điều 9. Thời gian lưu trữ dữ liệu cá nhân',
    children: (
      <>
        <div>
          <p>
            Vietstats lưu trữ dữ liệu cá nhân của Khách hàng trong khoảng thời
            gian cần thiết để hoàn thành các mục đích theo Chính sách này, trừ
            khi thời gian lưu trữ dữ liệu cá nhân lâu hơn được yêu cầu hoặc cho
            phép bởi các quy định pháp luật hiện hành.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '10',
    label: 'Điều 10. Sự đồng ý, chỉnh sửa, lưu trữ, xóa, hủy dữ liệu cá nhân',
    children: (
      <>
        <div>
          <label>10.1</label>
          <p>
            Chính sách này được công bố để Khách hàng hiểu rõ và đồng ý một cách
            tự nguyện trước khi Vietstats tiến hành thu thập, xử lý xử lý dữ
            liệu cá nhân của Khách hàng. Tùy vào quyết định của Vietstats, sự
            đồng ý của Khách hàng có thể được thể hiện bằng hình thức văn bản,
            các hình thức thông điệp dữ liệu, đánh dấu vào ô đồng ý, các hình
            thức tương đương văn bản hoặc các hình thức khác mà pháp luật không
            cấm.
          </p>
        </div>
        <div>
          <label>10.2</label>
          <p>
            Tùy vào đặc thù của từng sản phẩm dịch vụ của Vietstats, Khách hàng
            được xem, chỉnh sửa dữ liệu cá nhân đã cung cấp cho Vietstats bằng
            hình thức truy cập hồ sơ cá nhân để xem, chỉnh sửa; hoặc gửi yêu cầu
            bằng văn bản về cho Vietstats theo Thông tin liên hệ được quy định
            tại Chính sách này.
          </p>
        </div>
        <div>
          <label>10.3</label>
          <p>
            Trong những trường hợp bất khả kháng theo quy định pháp luật và
            chính sách này, Khách hàng đồng ý với Vietstats rằng không có một hệ
            thống an ninh nào trên toàn thế giới có thể đảm bảo an toàn 100% và
            có thể có những nhân tố vượt ra ngoài tầm kiểm soát của Vietstats
            dẫn đến việc dữ liệu cá nhân của Khách hàng bị tiết lộ mà không phải
            do sự cố ý của Vietstats. Do vậy, Vietstats nỗ lực áp dụng các biện
            pháp phù hợp trong khả năng cho phép, nhưng không đảm bảo dữ liệu cá
            nhân của Khách hàng sẽ được bảo mật tuyệt đối khi xảy ra sự cố ngoài
            ý muốn của Vietstats.
          </p>
        </div>
        <div>
          <label>10.4</label>
          <p>
            Khách hàng được quyền yêu cầu Vietstats xóa dữ liệu cá nhân đã cung
            cấp cho Vietstats trong các trường hợp sau: Nhận thấy không còn cần
            thiết cho mục đích thu thập đã đồng ý và chấp nhận các thiệt hại có
            thể xảy ra khi yêu cầu xóa dữ liệu; Rút lại sự đồng ý; Phản đối việc
            xử lý dữ liệu và Bên Kiểm soát dữ liệu cá nhân, Bên Kiểm soát và xử
            lý dữ liệu cá nhân không có lý do chính đáng để tiếp tục xử lý; Dữ
            liệu cá nhân được xử lý không đúng với mục đích đã đồng ý hoặc việc
            xử lý dữ liệu cá nhân là vi phạm quy định của pháp luật; Dữ liệu cá
            nhân phải xóa theo quy định của pháp luật. Việc xóa dữ liệu cá nhân
            sẽ không áp dụng khi có đề nghị của Khách hàng trong các trường hợp
            pháp luật không cho phép xóa dữ liệu.
          </p>
        </div>
        <div>
          <label>10.5</label>
          <p>
            Khi nhận được yêu cầu về việc thực hiện các quyền liên quan đến dữ
            liệu cá nhân của Khách hàng, Vietstats có thể sẽ thông báo cho Khách
            hàng về những hậu quả có khả năng xảy ra khi yêu cầu của Khách hàng
            được thực hiện.
          </p>
        </div>
        <div>
          <label>10.6</label>
          <p>
            Trong một số trường hợp, việc Khách hàng không đồng ý hoặc rút lại
            sự đồng ý cho phép xử lý dữ liệu cá nhân; yêu cầu hạn chế hoặc phản
            đối việc xử lý dữ liệu cá nhân; yêu cầu xóa dữ liệu cá nhân, có thể
            (i) ảnh hưởng đến hiệu lực pháp lý của hợp đồng, quan hệ pháp lý
            giữa Khách hàng và Vietstats; (ii) sản phẩm và dịch vụ của Vietstats
            đối với Khách hàng bị giới hạn, hạn chế, tạm ngừng, hủy bỏ một phần
            hoặc toàn phần tùy từng trường hợp. Vietstats sẽ không chịu trách
            nhiệm cho bất kỳ phí tổn, thiệt hại, tổn thất phát sinh cho Khách
            hàng và/hoặc Bên thứ ba có liên quan do sự ảnh hưởng này. Khi đó,
            quyền hợp pháp của Vietstats vẫn được bảo lưu đầy đủ, Vietstats vẫn
            có thể tiếp tục xử lý dữ liệu cá nhân của Khách hàng trong phạm vi
            được yêu cầu hoặc theo pháp luật hiện hành.
          </p>
        </div>
        <div>
          <label>10.7</label>
          <p>
            Khách hàng đồng ý và thừa nhận rằng bất kỳ việc rút lại sự đồng ý
            nào đối với việc xử lý dữ liệu cá nhân của Khách hàng sẽ không ảnh
            hưởng đến tính hợp pháp của việc xử lý dữ liệu cá nhân đã có trước
            thời điểm rút lại.
          </p>
        </div>
        <div>
          <label>10.8</label>
          <p>
            Khi nhận được yêu cầu xóa dữ liệu cá nhân từ Khách hàng, trước khi
            xóa dữ liệu cá nhân (dù là do Khách hàng rút lại sự đồng ý hoặc yêu
            cầu xóa dữ liệu cá nhân), Vietstats phải kiểm tra xem có bất kỳ lý
            do chính đáng hoặc trách nhiệm hoặc nghĩa vụ pháp lý nào đối với
            Vietstats liên quan đến việc Vietstats phải sao lưu, tiếp tục lưu
            trữ hoặc xử lý dữ liệu cá nhân hay không nhằm mục đích tuân thủ pháp
            luật.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '11',
    label: 'Điều 11. Miễn trừ trách nhiệm',
    children: (
      <>
        <div>
          <label>11.1</label>
          <p>
            Vietstats có thể chứa hoặc hiển thị các liên kết dẫn đến các website
            khác, ứng dụng khác mà Vietstats không kiểm soát. Theo đó, Vietstats
            không chịu trách nhiệm về việc xử lý dữ liệu cá nhân của các website
            khác, ứng dụng khác mà Khách hàng kết nối từ Vietstats.
          </p>
        </div>
        <div>
          <label>11.2</label>
          <p>
            Khách hàng có thể thấy tài liệu quảng cáo của bên thứ ba trên
            Website. Mỗi nhà quảng cáo tự chịu trách nhiệm về nội dung tài liệu
            quảng cáo của mình. Vietstats không chịu trách nhiệm về nội dung của
            tài liệu quảng cáo, bao gồm nhưng không giới hạn ở bất kỳ lỗi, thiếu
            sót nào.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '12',
    label: 'Điều 12. Cookies',
    children: (
      <>
        <div>
          <label>12.1</label>
          <p>
            Vietstats có sử dụng Cookies, một công nghệ lưu trữ thông tin như
            nhật ký sử dụng trên máy tính của người truy cập nhằm tạo điều kiện
            sử dụng các trang web tiện lợi hơn. Cookies sẽ lưu lại trạng thái
            trong lần truy cập cuối cùng của Khách hàng tại máy tính truy cập
            nhằm mục đích trả lại trạng thái này cho Khách hàng khi truy cập lần
            sau. Tuy nhiên, bằng cách thay đổi cài đặt trên trình duyệt
            Internet, Khách hàng có thể tắt cookies hoặc cài đặt cookies sao cho
            một cảnh báo sẽ xuất hiện trên màn hình máy tính trước khi cookies
            được cấp.
          </p>
        </div>
        <div>
          <label>12.2</label>
          <p>
            Vietstats có thể xử lý thông tin cá nhân của Khách hàng thông qua
            công nghệ cookie theo các quy định của Chính sách này. Vietstats
            cũng có thể sử dụng biện pháp tiếp thị lại để phân phát quảng cáo
            cho những cá nhân mà Vietstats biết trước đây đã truy cập trang tin
            điện tử của mình.
          </p>
        </div>
        <div>
          <label>12.3</label>
          <p>
            Trong phạm vi các bên thứ ba đã gán nội dung lên trên các trang tin
            điện tử của Vietstats (ví dụ: các tính năng truyền thông xã hội,
            quảng cáo), các bên thứ ba đó có thể thu thập thông tin cá nhân của
            Khách hàng (ví dụ: dữ liệu cookie) nếu Khách hàng chọn tương tác với
            nội dung của bên thứ ba đó hoặc sử dụng các dịch vụ của bên thứ ba.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '13',
    label: 'Điều 13. Sửa đổi, bổ sung Chính sách quyền riêng tư',
    children: (
      <>
        <div>
          <p>
            Khách hàng hiểu và đồng ý rằng, Chính sách này có thể được sửa đổi,
            bổ sung một phần hoặc toàn bộ theo từng thời kỳ và được thông báo
            tới Khách hàng thông qua Website và/hoặc các kênh thông tin mà
            Vietstats cho là phù hợp trước khi áp dụng. Việc Khách hàng tiếp tục
            sử dụng sản phẩm dịch vụ sau thời hạn thông báo về các nội dung sửa
            đổi, bổ sung trong từng thời kỳ đồng nghĩa với việc Khách hàng đã
            chấp nhận các nội dung sửa đổi, bổ sung đó.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '14',
    label: 'Điều 14. Thông tin liên hệ',
    children: (
      <>
        <div>
          <p>
            Trường hợp Khách hàng có bất kỳ câu hỏi nào liên quan đến Chính sách
            này, các vấn đề liên quan đến quyền của chủ thể dữ liệu cá nhân hoặc
            xử lý dữ liệu cá nhân của mình, Khách hàng vui lòng liên hệ với
            Vietstats theo thông tin sau:
          </p>
        </div>
        <div>
          <label>–</label>
          <p>
            Email: <Link href={`mailto:${CONTACT.EMAIL}`}>{CONTACT.EMAIL}</Link>
          </p>
        </div>
        <div>
          <label>–</label>
          <p>Số điện thoại: (+84) 338.922.229</p>
        </div>
        <div>
          <label>–</label>
          <p>
            Trụ sở Công ty: Tầng 3, Block B Tòa nhà Jamona Heights, 210 Bùi Văn
            Ba, phường Tân Thuận Đông, quận 7, thành phố Hồ Chí Minh.
          </p>
        </div>
      </>
    ),
  },
];

export const clauseItems = [
  {
    key: '1',
    label: 'Điều 1. Bản quyền và thương hiệu ',
    children: (
      <>
        <div>
          <p>
            WEBSITE và toàn bộ nội dung của WEBSITE, bao gồm nhưng không giới
            hạn các văn bản, dữ liệu, thiết kế, đồ họa, giao diện, hình ảnh, mã
            code … đều thuộc bản quyền của Vietstats trong khuôn khổ pháp luật
            cho phép hoặc bên thứ ba cấp phép cho Vietstats. Bản quyền của
            Vietstats được thể hiện trên WEBSITE bằng dòng chữ tiếng Anh
            “Copyright © 2024 Vietstats Co., Ltd. All Rights Reserved.”
          </p>
        </div>
        <div>
          <p>
            Bạn không được sửa đổi, sao chép, truyền tải, bán hoặc phân phối
            toàn bộ hoặc một phần WEBSITE này ngoại trừ việc Vietstats – bằng
            văn bản cấp cho bạn quyền sử dụng có giới hạn và với mục đích phi
            thương mại.
          </p>
        </div>
        <div>
          <p>
            Bạn không được sử dụng bất kỳ phần nào hoặc toàn bộ WEBSITE này để
            tạo một phần của trang web mới và/hoặc thậm chí khi bạn sử dụng các
            liên kết trên Internet để tạo ra trang web đó mà không có sự đồng ý
            trước bằng văn bản của Vietstats.
          </p>
        </div>
        <div>
          <p>
            Bất kể những điều đã nói ở trên, mọi phần mềm, dữ liệu, tài liệu
            khác được cung cấp để tải xuống, truy cập hoặc sử dụng cho mục đích
            khác từ WEBSITE với các điều khoản, điều kiện và thông báo cấp phép
            riêng sẽ chịu sự điều chỉnh của các điều khoản, điều kiện và thông
            báo đó. Việc vi phạm bất kỳ thỏa thuận nào trong số này sẽ dẫn đến
            việc tự động chấm dứt mọi quyền được cấp cho bạn mà không cần thông
            báo trước.
          </p>
        </div>
        <div>
          <p>
            Mặc dù Vietstats đã nghiêm cấm các hành vi và nội dung như vậy trên
            WEBSITE nhưng bạn hiểu và đồng ý rằng Vietstats không chịu trách
            nhiệm về nội dung được đăng trên WEBSITE mặc dù bạn có thể tiếp xúc
            với các tài liệu đó và bạn hoàn toàn chịu trách nhiệm về bất kỳ nội
            dung nào bạn tạo ra, truyền tải hoặc hiển thị khi sử dụng WEBSITE và
            về hậu quả hành động của bạn (bao gồm mọi mất mát hoặc thiệt hại mà
            Vietstats có thể phải gánh chịu) khi làm như vậy.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '2',
    label: 'Điều 2. Liên kết website',
    children: (
      <>
        <div>
          <p>
            Bạn không được tạo liên kết đến bất kỳ phần nào của WEBSITE trừ khi
            được Vietstats chấp thuận bằng văn bản và, như một điều kiện bổ sung
            để được phép liên kết đến WEBSITE, bạn đồng ý rằng Vietstats tại bất
            cứ lúc nào, theo quyết định riêng của mình, chấm dứt quyền liên kết
            đến WEBSITE.
          </p>
        </div>
        <div>
          <p>
            Trường hợp WEBSITE chứa các liên kết đến các trang web khác có điều
            khoản sử dụng và quy định riêng, vì Vietstats không kiểm soát bất kỳ
            nội dung hoặc hoạt động nào trên các trang web đó cũng như không ngụ
            ý bất kỳ bên thứ ba nào khác và/hoặc bất kỳ sản phẩm/dịch vụ tại
            trang web đó là của Vietstats, do đó, bạn hiểu và đồng ý rằng
            Vietstats không đảm bảo tính chính xác cũng như không chịu trách
            nhiệm trực tiếp hay gián tiếp đối với mọi thiệt hại có liên quan
            và/hoặc phát sinh từ bất kỳ nội dung hoặc sự an toàn nào trong bất
            kỳ hoạt động nào của các trang web đó, cũng như với mọi tổn hại hoặc
            thiệt hại hoặc bất kỳ chi phí nào phát sinh từ việc bạn tin tưởng và
            sử dụng nội dung, sản phẩm hoặc dịch vụ của các trang web được liên
            kết đó.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '3',
    label: 'Điều 3. Loại dữ liệu cá nhân được sử dụng',
    children: (
      <>
        <div>
          <label>3.1</label>
          <p>
            Trong khả năng phù hợp và điều kiện cho phép, Vietstats luôn cố
            gắng, nỗ lực thực hiện các biện pháp kỹ thuật cần thiết trong quá
            trình xây dựng và bảo trì WEBSITE, dù vậy, bạn hiểu và đồng ý rằng
            Vietstats không bảo đảm WEBSITE sẽ luôn đáp ứng tính kịp thời, an
            toàn hoặc không có lỗi, không bị gián đoạn trong quá trình hoạt
            động.
          </p>
        </div>
        <div>
          <label>3.2</label>
          <p>
            Bạn hiểu và đồng ý rằng việc sử dụng WEBSITE là quyết định của riêng
            bạn, và vì vậy, trách nhiệm và rủi ro thuộc về riêng bạn. Vietstats
            sẽ không chịu trách nhiệm với bạn hoặc bất kỳ bên thứ ba nào về tất
            cả các thiệt hại (bao gồm thiệt hại trực tiếp và gián tiếp) liên
            quan đến và/hoặc phát sinh từ việc sử dụng WEBSITE, bao gồm nhưng
            không giới hạn ở các các hành động tải/lấy tài liệu, thông tin,
            mua/bán sản phẩm, phần mềm, chương trình …
          </p>
        </div>
        <div>
          <label>3.3</label>
          <p>
            Nội dung công khai trên WEBSITE chỉ có mục đích cung cấp sản phẩm,
            dịch vụ liên quan đến dữ liệu và không được hiểu là tư vấn dưới bất
            kỳ hình thức nào. Do vậy, Vietstats không chịu trách nhiệm đảm bảo
            chất lượng, độ chính xác và đầy đủ của mọi dữ liệu, thông tin được
            cung cấp. <br />
            <i>
              (Xin lưu ý: Vietstats không phải là nguồn gốc của số liệu thống kê
              hay các cuộc khảo sát, mà là đơn vị tổng hợp và thu thập thông tin
              do các nguồn bên ngoài cung cấp. Trong các ấn phẩm, luôn trích dẫn
              nguồn thông tin.)
            </i>
          </p>
        </div>
        <div>
          <label>3.4</label>
          <p>
            Bạn cam kết chịu trách nhiệm tối đa đối với Vietstats và bên thứ ba
            về bất cứ trách nhiệm, tổn hại, thiệt hại, quyền pháp lý, tố tục
            pháp lý nào, chi phí (bao gồm chi phí pháp lý) liên quan đến hoặc
            phát sinh trực tiếp hoặc gián tiếp đến việc bạn vi phạm hoặc không
            tuân thủ bất kỳ điều khoản và điều kiện nào khi sử dụng trang
            WEBSITE này.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '4',
    label: 'Điều 4. Điều khoản thanh toán',
    children: (
      <>
        <div>
          <label>4.1</label>
          <p>
            Khi Khách Hàng thực hiện thao tác “Nâng cấp gói dữ liệu” trên
            Website/Ứng dụng, Chúng Tôi hiểu rằng Khách Hàng đã đọc kỹ, hiểu rõ
            và đầy đủ các thông tin về dịch vụ, giá cả và chấp nhận giao dịch.
          </p>
        </div>
        <div>
          <label>4.2</label>
          <p>
            Giá Gói dữ liệu được niêm yết trên Website/Ứng dụng là giá bán chưa
            bao gồm thuế Giá trị gia tăng (VAT). Giá cả của Gói dữ liệu và/hoặc
            toàn bộ đơn hàng có thể thay đổi tùy thời điểm và chương trình
            khuyến mại, phiếu chiết khấu kèm theo (nếu có) và sẽ được hiển thị
            công khai trên website/ứng dụng để khách hàng được biết.
          </p>
        </div>
        <div>
          <label>4.3</label>
          <p>
            Trong mọi trường hợp, Vietstats bảo lưu quyền từ chối đối với các
            yêu cầu hủy/thay đổi giao dịch từ Khách hang kể từ thời điểm giao
            dịch đã hoàn thành thanh toán.
          </p>
        </div>
        <div>
          <label>4.4</label>
          <p>
            Vietstats coi trọng việc bảo mật thông tin và sử dụng các biện pháp
            phù hợp để bảo vệ thông tin và việc thanh toán của Khách Hàng. Thông
            tin của Khách Hàng trong quá trình thanh toán sẽ được mã hóa để đảm
            bảo an toàn.
          </p>
        </div>
        <div>
          <label>4.5</label>
          <p>
            Khách Hàng có trách nhiệm cung cấp thông tin đầy đủ và chính xác khi
            tham gia giao dịch tại Website/Ứng dụng. Trong trường hợp Khách Hàng
            nhập sai thông tin, Vietstats có quyền từ chối thực hiện giao dịch.
            Trong trường hợp sai thông tin phát sinh từ phía Website/Ứng dụng ,
            chúng Tôi sẽ liên hệ Khách Hàng để giải quyết theo các chính sách
            tương ứng và có quyền không thực hiện giao dịch bị lỗi.
          </p>
        </div>
        <div>
          <label>4.6</label>
          <p>
            Trong trường hợp Bất Khả Kháng, VIETSTAS cũng có quyền hủy bỏ giao
            dịch nếu xét thấy sự kiện Bất Khả Kháng có thể kéo dài và ngăn cản
            Vietstats thực hiện nghĩa vụ của mình đối với hợp đồng giao dịch với
            Khách Hàng.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '5',
    label: 'Điều 5. Vi phạm & Chấm dứt dịch vụ',
    children: (
      <>
        <div>
          <p>
            Nếu bạn vi phạm hay có bất kỳ hành vi nào nhằm chống và/hoặc chống
            lại quy định pháp luật hiện hành nào, Điều kiện và Điều khoản sử
            dụng, Chính sách bảo về dữ liệu cá nhân hay bất kỳ quy định nào của
            Vietstats dưới bất kỳ hình thức nào, Vietstats có quyền trì hoãn,
            tạm dừng hoặc/và chấm dứt ủy quyền, quyền đã cấp cho bạn để tiếp
            cận, truy cập, sử dụng WEBSITE vào bất kỳ thời điểm nào theo quyết
            định riêng của mình.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '6',
    label: ' Điều 6. Chính sách bảo mật',
    children: (
      <>
        <div>
          <label>6.1</label>
          <p>
            Khách Hàng không được sử dụng bất kỳ chương trình, công cụ hay hình
            thức nào khác để can thiệp vào hệ thống hay làm thay đổi cấu trúc dữ
            liệu của WEBSITE. Nghiêm cấm việc phát tán, truyền bá hay cổ vũ cho
            bất kỳ hoạt động nào nhằm can thiệp, phá hoại hay xâm nhập vào hệ
            thống dữ liệu cũng như các hoạt động phát tán thông tin sai sự thật
            nhằm mục đích bôi xấu, ảnh hưởng tiêu cực đến thương hiệu Vietstats.
            Cá nhân hay tổ chức vi phạm sẽ bị tước bỏ mọi quyền lợi phát sinh từ
            việc sử dụng Website/Ứng dụng và chịu các trách nhiệm pháp lý khác
            theo quy định pháp luật.
          </p>
        </div>
        <div>
          <label>6.2</label>
          <p>
            Mọi thông tin giao dịch sẽ được bảo mật ngoại trừ trong trường hợp
            pháp luật hoặc cơ quan nhà nước có thẩm quyền yêu cầu.
          </p>
        </div>
        <div>
          <label>6.3</label>
          <p>
            Vui lòng bảo đảm bạn đã đọc, hiểu và đồng ý với nội dung{' '}
            <span>Chính sách bảo vệ dữ liệu cá nhân</span> của Vietstats.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '7',
    label: 'Điều 7. Chính sách giải quyết khiếu nại',
    children: (
      <>
        <div>
          <p>
            Vietstats cam kết dựa trên tiếng nói của Khách Hàng để định hướng
            cho việc quản trị và nỗ lực hiện thực hóa nguyện vọng của Khách Hàng
            trong tất cả các hoạt động kinh doanh. Do đó, Vietstats luôn sẵn
            sàng tiếp nhận và xử lý mọi ý kiến của của Khách Hàng (các câu hỏi,
            lời khen ngợi, đề xuất hoặc khiếu nại, ...) liên quan đến hoạt động
            tại Website/Ứng dụng.
          </p>
        </div>
        <div>
          <p>
            Quy trình tiếp nhận ý kiến và giải quyết khiếu nại được thực hiện
            theo các bước sau:
          </p>
        </div>
        <div>
          <label>B1:</label>
          <p>
            Khách Hàng có thể gửi ý kiến, dịch vụ đã đăng ký/mua trên
            Website/Ứng dụng qua các kênh sau:
          </p>
        </div>
        <ul>
          <li>
            Hotline: <Link href={`tel:${CONTACT.PHONE}`}>{CONTACT.PHONE}</Link>
          </li>
          <li>
            Email:
            <Link href={`mailto:${CONTACT.EMAIL}`}>{CONTACT.EMAIL}</Link>
          </li>
          <li>Giờ làm việc: 8h30 sáng – 17h00 chiều.</li>
        </ul>
        <div>
          <label>B2:</label>
          <p>
            Vietstats sẽ liên hệ để xác nhận và tìm hiểu thông tin đầy đủ cho
            yêu cầu của Khách Hàng trong vòng <span>48 giờ</span> kể từ khi nhận
            được yêu cầu này. Khách Hàng vui lòng cung cấp các thông tin, bằng
            chứng liên quan đến giao dịch, dịch vụ để xác minh và có hướng xử lý
            thích hợp và nhanh chóng.
          </p>
        </div>
        <div>
          <label>B3:</label>
          <p>
            Tùy theo tính chất và mức độ của sự việc, Vietstats sẽ có những biện
            pháp cụ thể để hỗ trợ Khách Hàng như sau:
          </p>
        </div>
        <ul>
          <li>
            Nếu có thể hỗ trợ/ xử lý, Vietstats sẽ đưa ra phương án và hỗ trợ
            Khách Hàng ngay trong lần phản hồi đầu tiên.
          </li>
          <li>
            Trường hợp cần thêm thời gian để rà soát, kiểm tra, chúng tôi sẽ
            phản hồi cho Khách Hàng trong vòng 48 - 96 giờ tiếp theo sau lần
            phản hồi đầu tiên/hoặc sau đã khi nhận đủ thông tin từ Khách Hàng.
          </li>
          <li>
            *** Trong trường hợp sau khi Chúng Tôi đã đưa ra các phương án hỗ
            trợ nhưng chưa đáp ứng được mong đợi của Khách Hàng, Chúng Tôi sẽ
            cần thêm thời gian để tìm các phương án hỗ trợ khác, phù hợp hơn cho
            Khách Hàng.
          </li>
        </ul>
        <div>
          <label>B4:</label>
          <p>
            Trong trường hợp sau khi Chúng Tôi đã nỗ lực đưa ra các phương án
            giải quyết khiếu nại hoặc khiếu nại này nằm ngoài khả năng giải
            quyết của Chúng Tôi thì Khách Hàng có thể yêu cầu đưa vụ việc ra
            giải quyết bởi cơ quan nhà nước có thẩm quyền.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '8',
    label: 'Điều 8. Luật áp dụng',
    children: (
      <>
        <div>
          <p>
            Các Điều khoản sử dụng này và các quy định được nêu dưới đây sẽ được
            điều chỉnh và hiểu theo luật pháp của nước Cộng hòa xã hội chủ nghĩa
            Việt Nam mà không gây ra xung đột với các quy định của pháp luật
            hoặc quốc gia, lãnh thổ cư trú thực tế của bạn. Mọi khiếu nại, tố
            tụng hoặc kiện tụng phát sinh liên quan đến các Điều khoản sử dụng
            này sẽ chỉ được đưa ra tại Việt Nam và bạn đồng ý với thẩm quyền xét
            xử của các tòa án đó.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '9',
    label: 'Điều 9. Thời gian lưu trữ dữ liệu cá nhân',
    children: (
      <>
        <div>
          <p>
            Trong quá trình hoạt động, Vietstats có quyền thay đổi, chỉnh sửa,
            thêm hoặc lược bỏ bất kỳ phần nào trong Điều Kiện và Điều Khoản Sử
            dụng này, vào bất cứ lúc nào. Các thay đổi có hiệu lực tại thời điểm
            là ngày được đăng tải và được ghi trong nội dung Điều Kiện và Điều
            Khoản Sử dụng. Khách hàng cần đọc kỹ Điều Kiện và Điều Khoản Sử dụng
            này kể cả các phiên bản sửa đổi, bổ sung trước khi thực hiện giao
            dịch. Việc Quý Khách tiếp tục sử dụng Website/Ứng dụng sau khi có
            các thay đổi về Điều Kiện và Điều Khoản Sử dụng được đăng tải, có
            nghĩa là Quý Khách đã đồng ý với những thay đổi đó
          </p>
        </div>
      </>
    ),
  },
];

export const purchaseTermsItems = [
  {
    key: '1',
    label: 'Điều 1. Dịch vụ Gói dữ liệu và quyền truy cập',
    children: (
      <>
        <div>
          <p>
            Mỗi Gói dữ liệu có mô tả rõ ràng về nội dung, số lượng dữ liệu được
            truy cập, thời hạn sử dụng, định dạng, cách thức cung cấp (tải về,
            API, gửi email, v.v.).
          </p>
        </div>
        <div>
          <p>
            Sau khi thanh toán thành công, quyền truy cập dữ liệu sẽ được kích
            hoạt tự động hoặc trong vòng tối đa 2 ngày làm việc (thời hạn kích
            hoạt tài khoản có thể bị trễ hơn khi gặp sự kiện bất khả kháng).
          </p>
        </div>
      </>
    ),
  },
  {
    key: '2',
    label: 'Điều 2. Thời hạn sử dụng',
    children: (
      <>
        <div>
          <p>
            Mỗi gói dữ liệu có thời hạn cụ thể. Hết thời hạn, quyền truy cập sẽ
            được tạm ngừng trừ khi bạn gia hạn hoặc nâng cấp gói dịch vụ.
          </p>
        </div>
        <div>
          <p>
            Thời gian sử dụng được tính từ thời điểm thanh toán hoặc/và kích
            hoạt tài khoản thành công.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '3',
    label: 'Điều 3. Hình thức thanh toán.',
    children: (
      <>
        <div>
          <p>
            Bạn có thể thanh toán bằng các phương thức hiển thị tại trang thanh
            toán. Bằng cách quét mã QR hiển thị trang thanh toán của{' '}
            <Link href="https://vietstats.vn">https://vietstats.vn</Link>. Hoặc
            chuyển khoản theo thông tin:
          </p>
        </div>
        <ul>
          <li>
            Đơn vị thụ hưởng: Công ty TNHH Tư Vấn Chiến Lược Chính Sách và Phân
            tích dữ liệu Kinh tế Vietstats.
          </li>
          <li>
            STK: 338922229 tại Ngân Hàng Thương Mại Cổ Phần Quân Đội (MB Bank)
          </li>
        </ul>
        <div>
          <p>
            Tất cả khoản thanh toán là không hoàn lại, trừ khi có lỗi phát sinh
            từ hệ thống của Vietstats khi quá thời hạn 2 ngày làm việc chưa cấp
            quyền truy cập hoặc/và cung cấp sai gói dịch vụ mà không phải do sự
            kiện bất khả kháng.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '4',
    label: 'Điều 4. Chính sách nâng cấp /chuyển Gói dữ liệu',
    children: (
      <>
        <div>
          <p>
            Bạn có thể nâng cấp Gói dữ liệu bất kỳ lúc nào. Khi nâng cấp, quyền
            lợi của gói mới sẽ được áp dụng ngay, và thời hạn sử dụng sẽ được
            tính lại theo gói mới.
          </p>
        </div>
        <div>
          <p>
            Lượt tải dữ liệu chưa dùng từ gói cũ sẽ được cộng thêm (nếu gói mới
            vẫn giới hạn lượt tải).
          </p>
        </div>
        <div>
          <p>
            Vietstats sẽ không hỗ trợ việc hạ cấp gói dữ liệu cũng như hoàn lại
            phí dịch vụ tương ứng cho các quyền lợi chưa sử dụng.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '5',
    label: 'Điều 5. Sử dụng hợp pháp và giới hạn trách nhiệm.',
    children: (
      <>
        <div>
          <p>
            Dữ liệu được cung cấp chỉ được sử dụng cho mục đích nội bộ hoặc
            nghiên cứu, không được sao chép, bán lại hoặc phát tán công khai
            dưới bất kỳ hình thức nào.
          </p>
        </div>
        <div>
          <p>
            Vietstats không chịu trách nhiệm về bất kỳ thiệt hại nào phát sinh
            từ việc sử dụng dữ liệu sai mục đích hoặc phân tích sai lệch từ
            người dùng.
          </p>
        </div>
        <div>
          <p>
            Người dùng có trách nhiệm bảo mật thông tin truy cập và không chia
            sẻ tài khoản.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '6',
    label: ' Điều 6. Hỗ trợ và khiếu nại',
    children: (
      <>
        <div>
          <p>
            Quy trình tiếp nhận ý kiến và giải quyết khiếu nại được thực hiện
            theo các bước sau:
          </p>
        </div>
        <div>
          <label>B1:</label>
          <p>
            Khách Hàng có thể gửi ý kiến, dịch vụ đã đăng ký/ mua trên
            Website/Ứng dụng qua các kênh sau:
          </p>
        </div>
        <ul>
          <li>
            Hotline: <Link href={`tel:${CONTACT.PHONE}`}>{CONTACT.PHONE}</Link>
          </li>
          <li>
            Email:
            <Link href={`mailto:${CONTACT.EMAIL}`}>{CONTACT.EMAIL}</Link>
          </li>
          <li>Giờ làm việc: 8h30 sáng – 17h00 chiều.</li>
        </ul>
        <div>
          <label>B2:</label>
          <p>
            Vietstats sẽ liên hệ để xác nhận và tìm hiểu thông tin đầy đủ cho
            yêu cầu của Khách Hàng trong vòng 2 ngày làm việc kể từ khi nhận
            được yêu cầu này. Khách Hàng vui lòng cung cấp các thông tin, bằng
            chứng liên quan đến giao dịch, dịch vụ để xác minh và có hướng xử lý
            thích hợp và nhanh chóng.
          </p>
        </div>
        <div>
          <label>B3:</label>
          <p>
            Tùy theo tính chất và mức độ của sự việc, VIETSTATS sẽ có những biện
            pháp cụ thể để hỗ trợ Khách Hàng như sau:
          </p>
        </div>
        <ul>
          <li>
            Nếu có thể hỗ trợ/ xử lý, VIETSTATS sẽ đưa ra phương án và hỗ trợ
            Khách Hàng ngay trong lần phản hồi đầu tiên.
          </li>
          <li>
            Trường hợp cần thêm thời gian để rà soát, kiểm tra, chúng tôi sẽ
            phản hồi cho Khách Hàng trong vòng 48 - 96 giờ tiếp theo sau lần
            phản hồi đầu tiên/hoặc sau đã khi nhận đủ thông tin từ Khách Hàng.
          </li>
          <li>
            Trong trường hợp sau khi Chúng Tôi đã đưa ra các phương án hỗ trợ
            nhưng chưa đáp ứng được mong đợi của Khách Hàng, Chúng Tôi sẽ cần
            thêm thời gian để tìm các phương án hỗ trợ khác, phù hợp hơn cho
            Khách Hàng.{' '}
          </li>
        </ul>
        <div>
          <label>B4:</label>
          <p>
            Trong trường hợp sau khi Chúng Tôi đã nỗ lực đưa ra các phương án
            giải quyết khiếu nại hoặc khiếu nại này nằm ngoài khả năng giải
            quyết của Chúng Tôi thì Khách Hàng có thể yêu cầu đưa vụ việc ra
            giải quyết bởi cơ quan nhà nước có thẩm quyền.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '7',
    label: 'Điều 7. Loại trừ nghĩa vụ của bên cung cấp',
    children: (
      <>
        <div>
          <p>
            Vietstats cam kết cung cấp dịch vụ tổng hợp dữ liệu theo đúng mô tả
            và tiêu chuẩn đã công bố, tuy nhiên không bảo đảm tuyệt đối tính
            hoàn chỉnh, cập nhật tức thời hoặc không có sai sót của dữ liệu, đặc
            biệt khi nguồn dữ liệu đầu vào đến từ bên thứ ba hoặc hệ thống công
            khai.
          </p>
        </div>
        <div>
          <p>Chúng tôi không chịu trách nhiệm đối với:</p>
        </div>
        <ul>
          <li>
            Các thiệt hại gián tiếp, mất mát tài chính, hoặc sai lệch trong phân
            tích/kết luận của người dùng do sử dụng dữ liệu.
          </li>
          <li>
            Việc sử dụng dữ liệu ngoài phạm vi cho phép, hoặc không đúng hướng
            dẫn của chúng tôi.
          </li>
          <li>
            Gián đoạn dịch vụ do lỗi hệ thống, bảo trì, hoặc nguyên nhân bất khả
            kháng (thiên tai, chiến tranh, mất kết nối Internet, tấn công mạng,
            v.v.).{' '}
          </li>
        </ul>

        <div>
          <p>
            Dữ liệu do Vietstats cung cấp là công cụ hỗ trợ ra quyết định, không
            phải là khuyến nghị đầu tư, pháp lý hay tài chính. Người dùng phải
            tự chịu trách nhiệm với cách sử dụng và hành động của mình dựa trên
            dữ liệu đó.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '8',
    label: 'Điều 8. Bảo hành dịch vụ dữ liệu',
    children: (
      <>
        <div>
          <p>
            Vietstats cung cấp dịch vụ gói dữ liệu trên cơ sở “như hiện có” và
            “như được cung cấp” tại website:{' '}
            <Link href="https://vietstats.vn">https://vietstats.vn</Link>. Chúng
            tôi không bảo hành hoặc cam kết tuyệt đối về độ chính xác, đầy đủ,
            kịp thời hay khả năng phù hợp với mục đích sử dụng cụ thể của người
            dùng.
          </p>
        </div>

        <div>
          <p>
            Dữ liệu được tổng hợp từ nhiều nguồn, bao gồm cả bên thứ ba và nguồn
            công khai, do đó có thể tồn tại sai sót khách quan hoặc thay đổi
            theo thời gian mà không được thông báo trước.
          </p>
        </div>

        <div>
          <p>
            Chúng tôi không bảo đảm rằng việc sử dụng dữ liệu sẽ mang lại kết
            quả chính xác, lợi ích tài chính, hay tránh được rủi ro trong hoạt
            động kinh doanh, nghiên cứu, hoặc đầu tư.
          </p>
        </div>

        <div>
          <p>
            Người dùng cần chủ động kiểm tra, đánh giá và chịu trách nhiệm với
            mọi quyết định được đưa ra dựa trên dữ liệu do chúng tôi cung cấp.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '9',
    label: 'Điều 9. Điều khoản bất khả kháng',
    children: (
      <>
        <div>
          <p>
            Vietstats sẽ không chịu trách nhiệm đối với bất kỳ thiệt hại, chậm
            trễ hoặc gián đoạn nào trong việc cung cấp dịch vụ nếu nguyên nhân
            xuất phát từ các sự kiện nằm ngoài khả năng kiểm soát hợp lý của
            chúng tôi, bao gồm nhưng không giới hạn ở: Thiên tai (lũ lụt, động
            đất, bão...) dịch bệnh, chiến tranh, biểu tình, lệnh cấm vận, sự cố
            về mạng viễn thông, Internet, hạ tầng máy chủ, hành vi phá hoại, tấn
            công mạng hoặc lỗi hệ thống của bên thứ ba, quy định pháp luật mới,
            thay đổi chính sách từ cơ quan nhà nước.
          </p>
        </div>
        <div>
          <p>
            Trong trường hợp xảy ra sự kiện bất khả kháng, chúng tôi sẽ nỗ lực
            thông báo cho khách hàng trong thời gian sớm nhất.Dịch vụ sẽ được
            tạm ngưng hoặc gia hạn tương ứng, tuỳ theo mức độ ảnh hưởng. Không
            bên nào phải chịu trách nhiệm bồi thường thiệt hại trong thời gian
            bất khả kháng, miễn là đã thực hiện mọi nỗ lực hợp lý để khắc phục.
          </p>
        </div>
      </>
    ),
  },
  {
    key: '10',
    label: 'Điều 9. Điều khoản chung',
    children: (
      <>
        <div>
          <p>
            Vietstats có quyền điều chỉnh nội dung điều khoản và gói dịch vụ
            theo thực tế. Mọi thay đổi sẽ được công bố trên website và có hiệu
            lực ngay khi cập nhật.
          </p>
        </div>
        <div>
          <p>
            Trong trường hợp bạn không đồng ý với các thay đổi mới, bạn có thể
            dừng sử dụng dịch vụ và không gia hạn tiếp.
          </p>
        </div>
      </>
    ),
  },
];
